import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <h1>www.davidtrejo.com</h1>
          <h2>www.davidtrejo.com</h2>
          <h3>www.davidtrejo.com</h3>
          <h4>www.davidtrejo.com</h4>
          <h5>www.davidtrejo.com</h5>
          <h6>www.davidtrejo.com</h6>
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
